/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAccountDraftRequest
 */
export interface CreateAccountDraftRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDraftRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDraftRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDraftRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDraftRequest
     */
    password: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAccountDraftRequest
     */
    areTermsAndConditionsAccepted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAccountDraftRequest
     */
    isOptedInToMarketingEmails: boolean;
}

/**
 * Check if a given object implements the CreateAccountDraftRequest interface.
 */
export function instanceOfCreateAccountDraftRequest(value: object): value is CreateAccountDraftRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('areTermsAndConditionsAccepted' in value) || value['areTermsAndConditionsAccepted'] === undefined) return false;
    if (!('isOptedInToMarketingEmails' in value) || value['isOptedInToMarketingEmails'] === undefined) return false;
    return true;
}

export function CreateAccountDraftRequestFromJSON(json: any): CreateAccountDraftRequest {
    return CreateAccountDraftRequestFromJSONTyped(json, false);
}

export function CreateAccountDraftRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAccountDraftRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'password': json['password'],
        'areTermsAndConditionsAccepted': json['areTermsAndConditionsAccepted'],
        'isOptedInToMarketingEmails': json['isOptedInToMarketingEmails'],
    };
}

export function CreateAccountDraftRequestToJSON(value?: CreateAccountDraftRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'password': value['password'],
        'areTermsAndConditionsAccepted': value['areTermsAndConditionsAccepted'],
        'isOptedInToMarketingEmails': value['isOptedInToMarketingEmails'],
    };
}

